import React from "react";
import { Linkedin, Mail, MessageCircle, Instagram } from "lucide-react";
import { PROFILE } from "../data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-[#0B0E14] text-[#F2EBE5] border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-7">
            <div className="text-[10px] uppercase tracking-overline text-[#D18A58] mb-4">Crafted with intent</div>
            <h3 className="font-display text-4xl md:text-5xl leading-tight tracking-tight">
              Currently accepting select <span className="italic text-[#D18A58]">collaborations</span> for 2025.
            </h3>
            <a
              href={`mailto:${PROFILE.email}`}
              data-testid="footer-email-link"
              className="mt-6 inline-block font-display italic text-2xl md:text-3xl text-[#F2EBE5] underline decoration-[#D18A58]/40 underline-offset-8 hover:text-[#D18A58]"
            >
              {PROFILE.email}
            </a>
          </div>
          <div className="md:col-span-5 md:pl-10 flex flex-col md:items-end gap-6">
            <div>
              <div className="text-[10px] uppercase tracking-overline text-[#8A8D98] mb-3">Elsewhere</div>
              <div className="flex md:justify-end gap-3">
                <a href={PROFILE.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#D18A58] hover:text-[#0B0E14] hover:border-[#D18A58] transition-all" aria-label="Instagram">
                  <Instagram className="h-4 w-4" />
                </a>
                <a href={PROFILE.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#D18A58] hover:text-[#0B0E14] hover:border-[#D18A58] transition-all" aria-label="LinkedIn">
                  <Linkedin className="h-4 w-4" />
                </a>
                <a href={PROFILE.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#D18A58] hover:text-[#0B0E14] hover:border-[#D18A58] transition-all" aria-label="WhatsApp">
                  <MessageCircle className="h-4 w-4" />
                </a>
                <a href={`mailto:${PROFILE.email}`} data-testid="footer-mail" className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-[#D18A58] hover:text-[#0B0E14] hover:border-[#D18A58] transition-all" aria-label="Email">
                  <Mail className="h-4 w-4" />
                </a>
              </div>
            </div>
            <div className="md:text-right">
              <div className="text-[10px] uppercase tracking-overline text-[#8A8D98] mb-2">Navigate</div>
              <div className="flex md:justify-end gap-5 text-sm">
                {[{l: "Work", h: "#portfolio"}, {l: "About", h: "#about"}, {l: "Services", h: "#services"}, {l: "Contact", h: "#contact"}].map(x => (
                  <a key={x.l} href={x.h} className="text-[#F2EBE5]/70 hover:text-[#D18A58]">{x.l}</a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="font-display text-[18vw] md:text-[14vw] lg:text-[12vw] leading-none tracking-tighter text-[#F2EBE5]/[0.06] select-none">
            Saanvi Gupte
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[10px] uppercase tracking-overline text-[#8A8D98]">
          <div>© {year} {PROFILE.name}. All rights reserved.</div>
          <div>Designed & built with care.</div>
        </div>
      </div>
    </footer>
  );
}
